/**
 * Verified public contact details for Swachh Bharat AI.
 * Display-only. Contact-form delivery still uses the existing backend config.
 *
 * Set `phone` / `whatsapp` only after a real business number is confirmed.
 * Until then those channels stay hidden.
 */
export const COMPANY_CONTACT = {
  companyName: 'Navidad Infotech Private Limited',
  contactPerson: 'Alan Anton Macwan',
  contactPersonRole: 'Director',
  email: 'alanmacwan@navidad.co.in',
  location: 'Anand, Gujarat, India',
  productWebsite: 'https://swachhbharat.app',
  productWebsiteHost: 'swachhbharat.app',
  companyWebsite: 'https://navidad.in',
  companyWebsiteHost: 'navidad.in',
  ecosystemWebsite: 'https://swachhai.in',
  ecosystemWebsiteHost: 'swachhai.in',
  phone: '+91 8460088418',
  whatsapp: '+91 8460088418',
} as const;

export const COMPANY_MAILTO = `mailto:${COMPANY_CONTACT.email}`;

export function companyPersonLine(): string {
  return `${COMPANY_CONTACT.contactPerson} — ${COMPANY_CONTACT.contactPersonRole}`;
}

function e164Digits(value: string): string {
  return value.replace(/\D/g, '');
}

export function companyTelHref(): string | null {
  if (!COMPANY_CONTACT.phone) return null;
  return `tel:+${e164Digits(COMPANY_CONTACT.phone)}`;
}

export function companyWhatsAppHref(): string | null {
  if (!COMPANY_CONTACT.whatsapp) return null;
  const digits = e164Digits(COMPANY_CONTACT.whatsapp);
  return digits ? `https://wa.me/${digits}` : null;
}
